module.exports = __webpack_public_path__ + "static/media/Brittany_Spears.4f211b04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Brittany_Spears.jpg
// module id = 411
// module chunks = 0